import axios from 'axios'

const functionsBaseURL = process.env.REACT_APP_FUNCTIONS_BASE_URL

export const cloudFunctionsInstance = axios.create({
  baseURL: functionsBaseURL
})
